import { ScheduleAnalyticsEvent } from "@/constants/analytics/Scheduling";
import { FAIconName } from "@/ui/core";

interface EditAppointmentContentProps {
  availabilityDescription: string;
  cancelAppointmentAnalyticsEvent: ValueOf<typeof ScheduleAnalyticsEvent>;
  cancelAppointmentButtonTitle: string;
  confirmationDescription: string;
  title: string;
  toggleModeButtonIcon: FAIconName;
  toggleModeButtonTitle: string;
}

interface CancelAppointmentContentProps {
  caption: string;
  description: string;
  title: string;
}

type EditAppointmentScope = "appointment" | "series";

const EditAppointmentContent: Record<
  EditAppointmentScope,
  EditAppointmentContentProps
> = {
  appointment: {
    availabilityDescription: "Please choose a new time for this appointment",
    cancelAppointmentAnalyticsEvent:
      ScheduleAnalyticsEvent.AppointmentDetailsCancel,
    cancelAppointmentButtonTitle: "Cancel appointment",
    confirmationDescription: "Please review the changes to this appointment",
    title: "Edit appointment",
    toggleModeButtonIcon: FAIconName.Pen,
    toggleModeButtonTitle: "Edit entire series",
  },

  series: {
    availabilityDescription:
      "Please choose a new time slot for this ongoing series",
    cancelAppointmentAnalyticsEvent:
      ScheduleAnalyticsEvent.AppointmentDetailsCancelAll,
    cancelAppointmentButtonTitle: "Cancel series",
    confirmationDescription: "Please review the changes to this series",
    title: "Edit series",
    toggleModeButtonIcon: FAIconName.ChevronLeft,
    toggleModeButtonTitle: "Back to single appointment",
  },
};

const CancelAppointmentContent: Record<
  EditAppointmentScope,
  CancelAppointmentContentProps
> = {
  appointment: {
    caption: "Please tell us why you're cancelling",
    description:
      "Are you sure you want to cancel this appointment? It's important to meet regularly with your provider.\n\nPlease note, cancelling this appointment will not cancel other future appointments in this series.",
    title: "Cancel appointment",
  },
  series: {
    caption: "Please tell us why you're cancelling",
    description:
      "Are you sure you want to cancel this series? It's important to meet regularly with your provider.",
    title: "Cancel series",
  },
};

export type { EditAppointmentScope };
export { CancelAppointmentContent, EditAppointmentContent };
